import { render, staticRenderFns } from "./cardSn.vue?vue&type=template&id=240e1106&scoped=true&"
import script from "./cardSn.vue?vue&type=script&lang=js&"
export * from "./cardSn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240e1106",
  null
  
)

export default component.exports